import React, { useEffect, useState} from 'react';
import { 
  Modal,
  Form,
  Input,
  message,
  Select,
  Col,
  Row,
  Table,
  Button,
  DatePicker,
  InputNumber,
  Spin,
} from 'antd';
import { observer } from 'mobx-react';
import { http, formatDate } from 'libs';
import store from './store';
import styles from './index.module.less';
import { UploadFile } from 'components';
import moment from 'moment'
import 'moment/locale/zh-cn';
import { cloneDeep } from 'lodash';
import FormUpload from "./FormUpload";
// import productStore from '../product/store';

export default observer(function IForm() {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isSale, setIsSale] = useState(true);
  const [projectItem, setProjectItem] = useState({});
  const [data, setData] = useState([]);
  const [record, setRecord] = useState({});
  // const [typeObj, setTypeObj] = useState({});
  const [column, setColumn] = useState([]);
  const [selectProduct, setSelectProduct] = useState({});

  const { Option } = Select;
  const { TextArea } = Input;

  // 销售订单表头
  const saleColumns = [
  //   {
  //   title: '设备名称',
  //   width: 120,
  //   dataIndex: 'brand',
  //   render: (value,_,index)=>
  //     <Input
  //       value={value}
  //       size='small'
  //       style={{ fontSize: '12px'}}
  //       onChange={v => updateData({ brand: v.target.value }, index)}
  //         />
  // },
   {
    title: '序列号',
    width: 150,
    dataIndex: 'deviceSerialNo',
  },{
    title: '送货联系人',
    width: 100,
    dataIndex: 'name',
  }, {
    title: '送货电话',
    width: 120,
    dataIndex: 'phone',
  },{
    title: '送货地址',
    dataIndex: 'address',
    width: 120,
  },  {
    title: '发货日期',
    width: 180,
    dataIndex: 'sendDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },{
    title: '物流单号',
    width: 70,
    dataIndex: 'expressNo',
  }, {
    title: '医院名称',
    width: 120,
    dataIndex:'hospitalName',
  }, {
    title: '中心号',
    width: 120,
    dataIndex: 'centerNo',
  }, {
    title: '校准起始日期',
    width: 125,
    dataIndex: 'certStartDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  }, {
    title: '校准结束日期',
    width: 125,
    dataIndex: 'certEndDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  }, {
    title: '备注',
    width: 120,
    dataIndex: 'remark',
  }, 
  // {
  //   title: '证书到期提醒日期',
  //   width: 125,
  //   dataIndex: 'certNoticeDate',
  //   render: (info)=>{
  //     if (info) {
  //       return moment(info).format("YYYY-MM-DD")
  //     }
  //     return null
  //   }
  // },
   {
    title: '操作',
    fixed:'right',
    width: 90,
    render: (info) => 
    <UploadFile
      fromEntity="OrderSale"
      catalog="Annex"
      itemInfo = {store.record}
      exportType = 'OrderExportCert'
      color="#47B2AC"
      fromEntityId={info.id || ''}
      isAbleUpload={false}
    />
  }];

  // 仓储订单表头
  const storeColumns = [
  //   {
  //   title: '设备名称',
  //   width: 100,
  //   dataIndex: 'brand'
  // }, 
  {
    title: '序列号',
    width: 150,
    dataIndex: 'deviceSerialNo',
  },{
    title: '取货日期',
    width: 100,
    dataIndex: 'pickupDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },{
    title: '取货联系人',
    width: 100,
    dataIndex: 'pickupName',
  }, {
    title: '取货电话',
    width: 180,
    dataIndex: 'pickupPhone',
  },{
    title: '取货地址', 
    dataIndex: 'pickupAddress', 
    width: 100,
  },   {
    title: '发货日期',
    width: 180,
    dataIndex: 'sendDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },{
    title: '物流单号',
    width: 70,
    dataIndex: 'expressNo',
  },{
    title: '货物入库状态', 
    width: 100, 
    dataIndex: 'status',
  }, {
    title: '随附配件',
    width: 125,
    dataIndex: 'itemContent',
  }, {
    title: '随附文件',
    width: 125,
    dataIndex: 'fileContent',
  }, {
    title: '校准起始日期',
    width: 125,
    dataIndex: 'certStartDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },{
    title: '校准结束日期',
    width: 125,
    dataIndex: 'certEndDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  }, {
    title: '存放地点',
    width: 125,
    dataIndex: 'storeName',
  }, {
    title: '入库日期',
    width: 125,
    dataIndex: 'inDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  }, {
    title: '出库日期',
    width: 125,
    dataIndex: 'outDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  }, {
    title: '计费开始日期',
    width: 125,
    dataIndex: 'feeStartDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  }, {
    title: '计费结束日期',
    width: 125,
    dataIndex: 'feeEndDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },
  //  {
  //   title: '证书到期提醒日期',
  //   width: 125,
  //   dataIndex: 'certNoticeDate',
  //   render: (info)=>{
  //     if (info) {
  //       return moment(info).format("YYYY-MM-DD")
  //     }
  //     return null
  //   }
  // },
  {
    title: '备注',
    width: 120,
    dataIndex: 'remark',
  },
   {
    title: '操作',
    fixed:'right',
    width: 90,
    render: (info) => 
    <UploadFile
      fromEntity="OrderStore"
      catalog="Annex"
      itemInfo = {store.record}
      exportType = 'OrderExportCert'
      color="#47B2AC"
      fromEntityId={info.id || ''}
      isAbleUpload={false}
    />
  }];

  // 计量订单表头
  const testingColumns = [
  //   {
  //   title: '设备名称',
  //   width: 100,
  //   dataIndex: 'brand'
  // },
   {
    title: '类型',
    width: 150,
    dataIndex: 'testingType',
  },{
    title: '序列号',
    width: 100,
    dataIndex: 'deviceSerialNo',
  },{
    title: '上门日期',
    width: 100,
    dataIndex: 'receiveDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },{
    title: '联系人',
    width: 125,
    dataIndex: 'name',
  }, {
    title: '电话',
    width: 125,
    dataIndex: 'phone',
  }, {
    title: '地址',
    width: 125,
    dataIndex: 'address',
  },  {
    title: '发货日期',
    width: 180,
    dataIndex: 'sendDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  }, {
    title: '物流单号', 
    dataIndex: 'expressNo', 
    width: 100,
  },{
    title: '校准起始日期',
    width: 125,
    dataIndex: 'certStartDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },{
    title: '校准结束日期',
    width: 125,
    dataIndex: 'certEndDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  }, 
  // {
  //   title: '医院名称',
  //   width: 125,
  //   dataIndex: 'hospitalName',
  // }, {
  //   title: '中心号',
  //   width: 125,
  //   dataIndex: 'centerNo',
  // },
  //  {
  //   title: '证书到期提醒日期',
  //   width: 125,
  //   dataIndex: 'certNoticeDate',
  //   render: (info)=>{
  //     if (info) {
  //       return moment(info).format("YYYY-MM-DD")
  //     }
  //     return null
  //   }
  // },
  {
    title: '备注',
    width: 120,
    dataIndex: 'remark',
  },
   {
    title: '操作',
    fixed:'right',
    width: 90,
    render: (info) => 
    <UploadFile
      fromEntity="OrderTesting"
      catalog="Annex"
      itemInfo = {store.record}
      exportType = 'OrderExportCert'
      color="#47B2AC"
      fromEntityId={info.id || ''}
      isAbleUpload={false}
    />
  }];

  // 转运订单表头
  const transferColumns = [
  //   {
  //   title: '设备名称',
  //   width: 100,
  //   dataIndex: 'brand'
  // },
   {
    title: '序列号',
    width: 100,
    dataIndex: 'deviceSerialNo',
  }, {
    title: '发货日期',
    width: 180,
    dataIndex: 'sendDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },{
    title: '物流单号', 
    dataIndex: 'expressNo', 
    width: 100,
  },{
    title: '取货日期',
    width: 100,
    dataIndex: 'pickupDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },{
    title: '取货联系人',
    width: 180,
    dataIndex: 'pickupName',
  },{
    title: '取货电话',
    width: 180,
    dataIndex: 'pickupPhone',
  }, {
    title: '取货地址',
    width: 180,
    dataIndex: 'pickupAddress',
  }, {
    title: '送货联系人',
    width: 180,
    dataIndex: 'sendName',
  },{
    title: '送货电话',
    width: 180,
    dataIndex: 'sendPhone',
  },{
    title: '送货地址',
    width: 180,
    dataIndex: 'sendAddress',
  }, {
    title: '医院名称',
    width: 125,
    dataIndex: 'hospitalName',
  }, {
    title: '中心号',
    width: 125,
    dataIndex: 'centerNo',
  }, {
    title: '备注',
    width: 120,
    dataIndex: 'remark',
  },{
    title: '操作',
    fixed:'right',
    width: 90,
    render: (info) => 
    <UploadFile
    fromEntity="OrderTransfer"
    catalog="Annex"
    itemInfo = {store.record}
    exportType = 'OrderExportCert'
    color="#47B2AC"
    fromEntityId={info.id || ''}
    isAbleUpload={false}
  />
  }];

  // 租赁订单表头
  const rentColumns = [
  //   {
  //   title: '设备名称',
  //   width: 100,
  //   dataIndex: 'brand',
  //   render: (info)=>
  //     <Input
  //       value={info}
  //       size='small'
  //       style={{ fontSize: '12px', width: 60 }}
  //       // onChange={v => updateNum({ number: v }, index)}
  //         />
  // },
  {
    title: '序列号',
    width: 100,
    dataIndex: 'deviceSerialNo',
  }, {
    title: '发货日期',
    width: 180,
    dataIndex: 'sendDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  }, {
    title: '物流单号',
    width: 70,
    dataIndex: 'expressNo',
  },{
    title: '租期',
    width: 100, 
    dataIndex: 'rentMonth',
  }, {
    title: '起租日期',
    width: 180,
    dataIndex: 'startDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },{
    title: '到期日期',
    width: 125,
    dataIndex: 'endDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  },{
    title: '退租日期',
    width: 125,
    dataIndex: 'exitDate',
    render: (info)=>{
      if (info) {
        return moment(info).format("YYYY-MM-DD")
      }
      return null
    }
  }, {
    title: '联系人',
    width: 125,
    dataIndex: 'name',
  }, {
    title: '电话',
    dataIndex: 'phone',
    width: 125,
  }, {
    title: '地址',
    dataIndex: 'address',
    width: 125,
  }, {
    title: '当前投放地点',
    dataIndex: 'hospitalAddress',
    width: 125,
  }, {
    title: '医院名称',
    width: 125,
    dataIndex: 'hospitalName',
  }, {
    title: '中心号',
    width: 125,
    dataIndex: 'centerNo',
  },
  //  {
  //   title: '租赁到期提醒日期',
  //   width: 125,
  //   dataIndex: 'noticeDate',
  //   render: (info)=>{
  //     if (info) {
  //       return moment(info).format("YYYY-MM-DD")
  //     }
  //     return null
  //   }
  // },
  {
    title: '备注',
    width: 120,
    dataIndex: 'remark',
  },
   {
    title: '操作',
    fixed:'right',
    width: 90,
    render: (info) =>  
    <UploadFile
      fromEntity="OrderRent"
      catalog="Annex"
      itemInfo = {store.record}
      exportType = 'OrderExportCert'
      color="#47B2AC"
      fromEntityId={info.id || ''}
      isAbleUpload={false}
    />
  }]

  const typeTieObj = {
    "Sale": {
      title: "销售",
      column: saleColumns,
      listName: 'orderSaleList',
    },
    "RentToSale": {
      title: "销售",
      column: saleColumns,
      listName: 'orderSaleList',
    },
    "Rent": {
      title: "租赁",
      listName: 'orderRentList',
      column: rentColumns
    },
    "Store": {
      title: "仓储",
      listName: 'orderStoreList',
      column: storeColumns
    },
    "Testing": {
      title: "计量",
      listName: 'orderTestingList',
      column: testingColumns
    },
    "Transfer": {
      title: "转运",
      listName: 'orderTransferList',
      column: transferColumns
    },
  };

  // useEffect(() => {
  //   if (productStore.records.length === 0) productStore.fetchRecords();
  // }, [])

  useEffect(()=>{
    let cloneRecord = cloneDeep(record);
    cloneRecord.deviceMaterialCode = selectProduct.material_code;
    cloneRecord.deviceProductId = selectProduct.id;
    cloneRecord.deviceProductName = selectProduct.brand;
  },[selectProduct])

  useEffect(()=>{
    setRecord(store.record)
    if(store.record.catalog){
      setIsSale(store.record.catalog === 'Sale'||store.record.catalog === 'RentToSale')
      const defaultData = store.record[typeTieObj[store.record.catalog]?.listName];
      const defaultColumn = typeTieObj[store.record.catalog].column;
      setColumn(defaultColumn)
      setData(defaultData);
    };


  },[store.record])

  return (
    <Modal
      visible
      maskClosable={false}
      closable={true}
      title='查看订单信息'
      onCancel={()=>store.formVisible = false}
      confirmLoading={loading}
      className={styles.modalContainer}
      width={1400}>
        {
          store.formLoading?
          <Spin/>:
          <>
            {/* <Spin spinning={store.formLoading}> */}
              <Form form={form} labelCol={{ span: 5 }} wrapperCol={{ span: 18 }} size={'middle'} labelAlign={'right'} initialValues={store.record}>
            <h3><strong>{store.typeObj[record.catalog]}</strong></h3>
            <Row >
                <Col span={8}>
                <Form.Item label="下单日期">
                    <div>{formatDate(record.createdAt)}</div>
                  </Form.Item>
                  <Form.Item label="产品品牌" >
                      <div>{record.brandName}</div>
                  </Form.Item>
                  <Form.Item  label="未税总价">
                    <div>{record.totalPriceWithoutTax}</div>
                  </Form.Item>
                  <Form.Item label="设备名称">
                    <div>{record.deviceProductName}</div> 
                </Form.Item>
                  <Form.Item label="项目号">
                  <div>{record.projectNo}</div> 
                  </Form.Item>
                  <Form.Item name='invoicePrice' label="开票金额" >
                  <div>{record.invoicePrice}</div> 
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="订单号">
                    <div>{record.orderSn}</div>
                  </Form.Item>
                  <Form.Item label="货号">
                  <div>{record.factoryCode}</div>
                  </Form.Item>
                  <Form.Item  label="含税总价" >
                  <div>{record.totalPrice}</div>
                  </Form.Item>
                  <Form.Item  label="设备编码" >
                  <div>{record.deviceMaterialCode}</div>
                  </Form.Item>
                  <Form.Item  label="申请人" >
                  <div>{record.applyUserName}</div>
                  </Form.Item>
                  <Form.Item name='invoiceDate' label="开票日期" >
                  <div>{formatDate(record.invoiceDate)}</div>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item  label="产品名称" >
                  <div>{record.goodsName}</div>
                  </Form.Item>
                  <Form.Item  label="产品编码" >
                  <div>{record.materialCode}</div>
                  </Form.Item>
                  <Form.Item  label="税率" >
                  <div>{(record.taxRate||record.taxRate===0)&&`${record.taxRate}%`}</div>
                  </Form.Item>
                  <Form.Item  label="整单数量" >
                  <div>{record.number}</div>
                  </Form.Item>
                  <Form.Item label="PO号" >
                  <div>{record.purchaseNo}</div>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={8}>
                  <Form.Item label="用户备注" >
                    <div>{record.userRemark}</div>
                  </Form.Item>
                </Col>
                {/* <Col span={8}>
                  <Form.Item label="泉心备注" >
                  <div>{record.selfRemark}</div>
                  </Form.Item>
                </Col> */}
              </Row>
            </Form>
            <Table
                rowKey='id'
                className={styles.Table}
                pagination={false}
                scroll={{ x: 1400 }}
                columns={column}
                dataSource={data}>
            </Table>
        {/* </Spin> */}
          </>
        }
      
      {store.formUploadVisible && <FormUpload />}
    </Modal>

  )
})